import criterias from "./criterias";
import layout from "./layout";
import masterSupplier from "./masterSupplier";
import masterForex from "./fowardContact";
import account from "./account";
import shipmentDetail from "./shipmentDetail";
import claimCreate from "./claimCreate.js";
import claimSearch from "./claimSearch";
import claimDocument from "./claimDocument";
import annoucement from "./annoucement";
import hangfire from "./hangfire";
import home from "./home";
import masterTb from "./masterTb";
import listTos from "./listTos";
import masterPaymentTerm from "./masterPaymentTerm";
const reducers = {
  criterias,
  layout,
  masterSupplier,
  masterForex,
  account,
  shipmentDetail,
  claimCreate,
  claimSearch,
  claimDocument,
  annoucement,
  hangfire,
  home,
  masterTb,
  listTos,
  masterPaymentTerm,
};

export default reducers;
